import React from "react";
import Header from "./Header";

const Footer = () => (
  <footer className="border-t border-border mt-24">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div>
        <div className="font-serif text-xl">AstroSamagri ✦</div>
        <p className="text-xs text-muted-foreground mt-1">Vedic wisdom meets authentic sacred goods.</p>
      </div>
      <p className="text-[11px] uppercase tracking-label text-muted-foreground">© {new Date().getFullYear()} · Made with reverence</p>
    </div>
  </footer>
);

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-background text-foreground">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default Layout;
